import React from 'react';
import { MenuDataItem } from '@ant-design/pro-layout';
import * as allIcons from '@remixicon/react';

// 将字符串格式的图标名称转换为 Remix Icons 组件名称格式
// 例如：group-3-line -> RiGroup3Line
const convertToRemixIconName = (iconName: string): string => {
  // 如果已经是 Ri 开头，直接返回
  if (iconName.startsWith('Ri')) {
    return iconName;
  }
  
  // 分割字符串
  const parts = iconName.split('-');
  
  // 转换为驼峰命名并添加 Ri 前缀
  let camelCaseName = 'Ri';
  for (const part of parts) {
    camelCaseName += part.charAt(0).toUpperCase() + part.slice(1);
  }
  
  return camelCaseName;
};

// FIX从接口获取菜单时icon为string类型
const fixMenuItemIcon = (menus: MenuDataItem[]): MenuDataItem[] => {
  menus.forEach((item) => {
    const { icon, children } = item;
    if (typeof icon === 'string') {
      // 将图标名称转换为 Remix Icons 格式
      const fixIconName = convertToRemixIconName(icon);
      
      const IconComponent = (allIcons as any)[fixIconName] || (allIcons as any)[icon];
      item.icon = IconComponent ? React.createElement(IconComponent, { size: 16 }) : null;
    }
    children && children.length > 0 ? (item.children = fixMenuItemIcon(children)) : null;
  });
  return menus;
};

export default fixMenuItemIcon;